<template>
  <div class="record">
    <div v-if="$isMobile()" class="alt-table-responsive">
      <table class="table" width="100%">
        <thead>
          <tr>
            <th :key="field.key" v-for="field in [{key: 'name'}, {key: 'value'}]" style="color: #06f">
              {{ field.key }}
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- {{ columns_to_check }} -->
          <template v-for="item in columns_to_check">
            <tr :key="item.name">
              <td :data-label="formatLabel(item.name)">
                {{record[0][item.name]}}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <b-table
      v-else
      show-empty
      hover
      small
      head-variant="dark"
      thead-class="d-none"
      :items="columns_to_check"
      :fields="[{key: 'name'}, {key: 'value'}]">
      <template v-slot:cell(name)="data">
        <span class="text-primary">
          {{ formatLabel(data.value) }}
        </span>
      </template>
      <template v-slot:cell(value)="data">
        {{ record[0][data.item.name] }}
      </template>
    </b-table>
  </div>
  <!-- <div class="record">
    <b-table
      show-empty
      hover
      small
      head-variant="dark"
      thead-class="d-none"
      :items="columns_"
      :fields="[{key: 'name'}, {key: 'value'}]">
      <template v-slot:cell(name)="data">
        <span class="text-primary">
          {{ data.value }}
        </span>
      </template>
      <template v-slot:cell(value)="data">
        {{ record[data.value] }}
      </template>
    </b-table>
  </div> -->

  <!-- <div class="record">
    <b-table
      hover
      :items="columns_"
     >
      
    </b-table>
  </div> -->
</template>

<script>
  import {titleCase} from '../Insights/utils';

  export default {
    name: 'Record',

    props: {
      fileType: {
        type: String,
        required: true
      },
      record: {
        type: Object,
        required: true
      }
    },

    methods: {
      formatLabel(label) {
        return label.split("_").slice(1, -2).join(" ");
      }
    },

    computed: {
      column_keys(){
        return this.columns_.map(e =>
          Object.keys(e)
        )
      },
      columns() {
        return this.column_keys.map(col => ({
            name: titleCase(col)
          }));
      },
      columns_() {
        return this.record;
      },
      columns_to_check(){
        const columns_2 = this.column_keys;
        return columns_2[0].map(e=>({name:e}))
      }
    }
  };
</script>

<style>
  .record .table tbody tr:first-child td {
    border-top: none;
  }

  @media screen and (max-width: 768px) {
    .alt-table-responsive table thead {
      display: none;
    }

    .alt-table-responsive table tr {
      display: block;
      border-top: 1px dashed lightgray;
      margin-top: 5px;
      margin-bottom: 2px;
    }

    .alt-table-responsive table td {
      display: block;
      text-align: right;
    }

    .alt-table-responsive table td:before {
      content: attr(data-label);
      float: left;
      color: #3af;
      font-weight: 700;
    }
  }
</style>
